// Base
import { BaseApi } from '../base.api'

// Interface
import {
  IAboutUsWebpageApi,
  IAboutUsWebpageApiRequest,
  IAboutUsWebpageApiResponse,
  IAboutUsWebpageGetAttrs,
} from 'interfaces/webpage/about-us'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsWebpageApi extends BaseApi<IAboutUsWebpageApi> implements IAboutUsWebpageApiRequest {
  readonly url = ApiConstant.ABOUT_US_URL
  private aboutUsUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get about us webpage
   *
   * @method POST
   * @url /tentang-kami
   * @access public
   *
   * @return {Promise<IAboutUsWebpageApiResponse>} Promise<IAboutUsWebpageApiResponse>
   */
  async aboutUsWebpage_getAboutUs(payload: IAboutUsWebpageGetAttrs): Promise<IAboutUsWebpageApiResponse> {
    try {
      const response: IAboutUsWebpageApiResponse = await this.POST(this.aboutUsUrl, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
